@import '@speechki-frontend/shared/assets/scss/_vars';

.mass-replacement-sentence {
    position: relative;
    display: flex;
    font-size: 12px;
    margin-bottom: 8px;
    padding: 20px 10px;
    line-height: 22px;
    justify-content: space-between;
    background-color: $bg;
    border-radius: 15px;

    &__diff {
        font-family: monospace;
        font-size: 14px;
        padding: 0 1px;

        &--removed {
            background-color: rgba($orange, 0.5);
        }

        &--added {
            background: rgba($green, 0.5);
        }
    }

    &__actions {
        min-width: 160px;
        padding: 0 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
}
